// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__9SSYX","logo":"footer_logo__vRglU","section":"footer_section__NoNUA","heading":"footer_heading__eEYmr","social":"footer_social__FiIut"};